import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { injectIntl, FormattedMessage } from "react-intl";
import styles from "./Page.module.css";
import CtaButton from "../components/CtaButton";

const AboutPage = ({ intl }) => {
  return (
    <>
      <Helmet>
        <title>{intl.formatMessage({ id: "about.title" })} - Vertex4D</title>
        <meta
          name="description"
          content={intl.formatMessage({ id: "about.subtitle" })}
        />
      </Helmet>
      <main>
        <header className={styles.pageHeader}>
          <div className={styles.container}>
            <div className={styles.breadcrumb}>
              <Link to="/">
                <FormattedMessage
                  id="breadcrumb.home"
                  defaultMessage="Início"
                />
              </Link>{" "}
              &gt;{" "}
              <span>
                <FormattedMessage id="about.title" />
              </span>
            </div>
            <h1>
              <FormattedMessage id="about.title" />
            </h1>
            <p className={styles.pageSubtitle}>
              <FormattedMessage id="about.subtitle" />
            </p>
          </div>
        </header>
        <section className={styles.pageContent}>
          <div className={`${styles.container} ${styles.contentCentered}`}>
            <div className={styles.contentBlock}>
              <h2>
                <FormattedMessage id="about.content.title" />
              </h2>
              <p>
                <FormattedMessage id="about.content.p1" />
              </p>
              <p>
                <FormattedMessage id="about.content.p2" />
              </p>
              <p>
                <FormattedMessage id="about.content.p3" />
              </p>
            </div>
          </div>
        </section>
        <section className={styles.pageCta}>
          <div className={styles.container}>
            <div className={styles.ctaBoxLarge}>
              <h2>
                <FormattedMessage id="about.cta.title" />
              </h2>
              <p>
                <FormattedMessage id="about.cta.subtitle" />
              </p>
              <CtaButton
                href="/register"
                variant="secondary"
              >
                <FormattedMessage id="about.cta.button" />
              </CtaButton>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default injectIntl(AboutPage);

